




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import 'echarts-wordcloud';

const words = [
  // 组织机构
  '共青团广西',
  '广西省团委',
  '广西团委',
  '南宁市团委',
  '南宁共青团',
  '共青团',
  '百色',
  '北海',
  '崇左',
  '防城港',
  '桂林',
  '贵港',
  '河池',
  '贺州',
  '来宾',
  '柳州',
  '南宁',
  '钦州',
  '梧州',
  '玉林',
  '广西',
  '市团委',
  '校园',
  '学生',
  '团委',
  '百色共青团',
  '百色市团委',
  '北海共青团',
  '北海市团委',
  '崇左共青团',
  '崇左市团委',
  '防城港共青团',
  '防城港市团委',
  '桂林共青团',
  '桂林市团委',
  '贵港共青团',
  '贵港市团委',
  '河池共青团',
  '河池市团委',
  '贺州共青团',
  '贺州市团委',
  '来宾共青团',
  '来宾市团委',
  '柳州市团委',
  '柳州共青团',
  '钦州共青团',
  '钦州市团委',
  '梧州共青团',
  '梧州市团委',
  '玉林共青团',
  '玉林市团委',

  // 教育相关
  '初中',
  '高中',
  '小学',
  '中学',
  '学校',
  '职教中心',
  '职业教育中心',
  '中考',
  '考试中心',
  '教育',
  '培训',
  '课程',
  '教学',
  '教师',
  '老师',
  '班主任',
  '校长',
  '教育局',
  '学期',
  '寒假',
  '暑假',
  '开学',
  '毕业',
  '升学',
  '招生',
  '录取',

  // 学生相关
  '学生安全',
  '学生代表',
  '学生返乡',
  '学生会',
  '学生举报',
  '学生抗议',
  '学生失踪',
  '学生死活',
  '学生死亡',
  '学生跳楼',
  '学生信息',
  '学生游行',
  '同学',
  '学联',
  '班级',
  '年级',
  '宿舍',
  '食堂',
  '图书馆',
  '操场',
  '教室',

  // 青少年活动
  '青年团',
  '青少年宫',
  '少先队',
  '红领巾',
  '志愿者',
  '青年大学习',
  '社会实践',
  '夏令营',
  '冬令营',
  '文艺演出',
  '体育比赛',
  '知识竞赛',
  '志愿服务',
  '公益活动',
  '社团活动',
  '文化节',
  '艺术节',
  '科技节',

  // 安全问题
  '校园霸凌',
  '校园暴力',
  '校园欺凌',
  '网络暴力',
  '电信诈骗',
  '校园贷',
  '毒瘾',
  '网瘾',
  '裸贷',
  '防范非法集资',
  '禁毒',
  '留守儿童',
  '民愤',
  '安全教育',
  '消防安全',
  '交通安全',
  '食品安全',
  '心理健康',
  '心理咨询',

  // 意外伤害类
  '意外伤害',
  '意外事故',
  '安全事故',
  '校园事故',
  '溺水',
  '坠楼',
  '跌倒',
  '烫伤',
  '烧伤',
  '中毒',
  '触电',
  '火灾',
  '爆炸',
  '踩踏',
  '碰撞',
  '摔伤',
  '割伤',
  '扭伤',
  '骨折',
  '窒息',
  '食物中毒',
  '煤气中毒',
  '化学中毒',
  '交通事故',
  '车祸',
  '撞车',
  '翻车',
  '坠车',
  '运动伤害',
  '体育伤害',
  '实验事故',
  '化学实验',
  '物理实验',
  '生物实验',
  '实验室安全',
  '建筑事故',
  '施工事故',
  '高空坠物',
  '塌陷',
  '滑坡',
  '泥石流',
  '自然灾害',
  '地震',
  '洪水',
  '台风',
  '雷击',
  '冰雹',
  '暴雨',
  '干旱',
  '急救',
  '救护',
  '医疗救助',
  '紧急救援',
  '应急处理',
  '安全防护',
  '防护措施',
  '安全设备',
  '防护用品',
  '警示标识',
  '安全检查',
  '风险评估',
  '隐患排查',
  '事故预防',
  '安全培训',
  '应急演练',

  // 心理健康
  '青少年心理健康',
  '心理问题',
  '心理疏导',
  '心理辅导',
  '抑郁症',
  '焦虑症',
  '心理压力',
  '情绪管理',
  '人际关系',
  '学习压力',
  '考试焦虑',
  '青春期',

  // 心理危机相关
  '自杀',
  '自残',
  '轻生',
  '自杀倾向',
  '自杀行为',
  '自杀预防',
  '心理危机',
  '危机干预',
  '情绪失控',
  '绝望',
  '厌世',
  '消极情绪',
  '极端行为',
  '心理创伤',
  '精神障碍',
  '心理障碍',
  '情感障碍',
  '双相情感障碍',
  '强迫症',
  '恐惧症',
  '社交恐惧',
  '厌食症',
  '暴食症',
  '睡眠障碍',
  '失眠',
  '噩梦',
  '惊恐发作',
  '心理治疗',
  '药物治疗',
  '住院治疗',
  '心理医生',
  '精神科医生',
  '心理咨询师',
  '危机热线',
  '求助热线',

  // 网络相关
  '网络安全',
  '网络监管',
  '网络文明',
  '网络素养',
  '网络游戏',
  '网络成瘾',
  '信息安全',
  '数据保护',
  '隐私保护',
  '网络诈骗',
  '网络犯罪',
  '网络举报',

  // 法律法规
  '法律教育',
  '法治宣传',
  '未成年人保护法',
  '教育法',
  '刑法',
  '民法',
  '法律援助',
  '法律咨询',
  '维权',
  '诉讼',
  '仲裁',
  '调解',

  // 社会热点
  '疫情防控',
  '健康码',
  '核酸检测',
  '疫苗接种',
  '口罩',
  '消毒',
  '隔离',
  '线上教学',
  '网课',
  '直播教学',
  '在线学习',
  '数字化教育',
  '智慧校园',

  // 职业规划
  '就业',
  '创业',
  '实习',
  '职业规划',
  '技能培训',
  '职业技能',
  '求职',
  '面试',
  '简历',
  '招聘',
  '岗位',
  '薪资',
  '福利',
  '社保',

  // 文化娱乐
  '文化活动',
  '体育运动',
  '音乐',
  '舞蹈',
  '绘画',
  '书法',
  '摄影',
  '阅读',
  '写作',
  '演讲',
  '辩论',
  '社团',
  '兴趣小组',
  '才艺表演',

  // 时事政治
  '党建',
  '思想政治',
  '爱国主义',
  '社会主义',
  '中国梦',
  '新时代',
  '党史学习',
  '红色教育',
  '革命传统',
  '民族精神',
  '时代精神',

  // 特殊事件
  '11盆开水',

  // 常用词汇
  '活动',
  '会议',
  '通知',
  '公告',
  '新闻',
  '报道',
  '宣传',
  '推广',
  '组织',
  '参与',
  '开展',
  '举办',
  '承办',
  '协办',
  '支持',
  '配合',
  '工作',
  '任务',
  '计划',
  '方案',
  '措施',
  '要求',
  '目标',
  '成果',
  '发展',
  '建设',
  '改革',
  '创新',
  '进步',
  '提升',
  '完善',
  '加强',
  '管理',
  '监督',
  '检查',
  '评估',
  '总结',
  '汇报',
  '交流',
  '合作',
];

@Component({})
export default class Wordcloud extends Vue {
  @Prop({ default: '' }) readonly inputText!: string;

  private myChart: any = null;

  // 监听输入文本变化
  @Watch('inputText')
  onInputTextChange() {
    if (this.myChart) {
      this.updateChart();
    }
  }

  mounted() {
    (this as any).$nextTick(() => {
      this.init();
      this.addResizeListener();
    });
  }

  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    this.removeResizeListener();
  }

  addResizeListener() {
    window.addEventListener('resize', this.handleResize);
  }

  removeResizeListener() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this.myChart) {
      this.myChart.resize();
    }
  }

  // 根据words数组进行分词统计（增强版）
  segmentTextByWords(text: string): Array<{ name: string; value: number }> {
    if (!text || text.trim() === '') {
      return [];
    }

    // 统计词频
    const wordCount: { [key: string]: number } = {};

    // 1. 精确匹配words数组中的词
    words.forEach(word => {
      const regex = new RegExp(word, 'g');
      const matches = text.match(regex);
      if (matches) {
        wordCount[word] = matches.length;
      }
    });

    // 转换为词云数据格式，按频次排序
    const wordCloudData = Object.entries(wordCount)
      .map(([name, count]) => ({
        name,
        value: count * 50 + Math.random() * 100, // 增加随机性避免重复值
      }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 80); // 增加到80个词

    return wordCloudData;
  }

  // 中文停用词过滤
  isStopWord(word: string): boolean {
    const stopWords = [
      '的',
      '了',
      '在',
      '是',
      '和',
      '有',
      '对',
      '不',
      '这',
      '个',
      '他',
      '她',
      '它',
      '我',
      '你',
      '们',
      '都',
      '也',
      '就',
      '可以',
      '能够',
      '如果',
      '因为',
      '所以',
      '但是',
      '然而',
      '而且',
      '或者',
      '一个',
      '一些',
      '进行',
      '通过',
      '根据',
      '按照',
      '为了',
      '由于',
      '关于',
      '其中',
      '包括',
      '除了',
      '另外',
      '此外',
      '以及',
      '以上',
      '以下',
      '如下',
      '上述',
      '下面',
      '现在',
      '目前',
      '今天',
      '昨天',
      '明天',
      '这样',
      '那样',
      '这里',
      '那里',
      '这种',
      '那种',
      '各种',
    ];
    return stopWords.includes(word) || word.length < 2;
  }

  // 英文停用词过滤
  isEnglishStopWord(word: string): boolean {
    const stopWords = [
      'the',
      'a',
      'an',
      'and',
      'or',
      'but',
      'in',
      'on',
      'at',
      'to',
      'for',
      'of',
      'with',
      'by',
      'is',
      'are',
      'was',
      'were',
      'be',
      'been',
      'have',
      'has',
      'had',
      'do',
      'does',
      'did',
      'will',
      'would',
      'could',
      'should',
      'may',
      'might',
      'can',
      'this',
      'that',
      'these',
      'those',
      'it',
      'its',
      'he',
      'she',
      'they',
    ];
    return stopWords.includes(word) || word.length < 2;
  }

  updateChart() {
    if (!this.myChart) return;

    const datas = this.segmentTextByWords(this.inputText);
    const option = this.getChartOption(datas);
    this.myChart.setOption(option);
  }

  getChartOption(datas: Array<{ name: string; value: number }>) {
    return {
      tooltip: {
        show: false,
        position: 'top',
        textStyle: {
          fontSize: 30,
        },
      },
      series: [
        {
          type: 'wordCloud',
          gridSize: 5,
          shape: 'circle',
          sizeRange: [20, 60],
          rotationRange: [-45, 0, 45, 90],
          rotationStep: 45,
          left: 'center',
          top: 'center',
          right: null,
          bottom: null,
          width: '90%',
          height: '80%',
          drawOutOfBound: false,
          textStyle: {
            normal: {
              color: function(params: { name: any }) {
                const wordName = params.name;

                // 组织机构类 - 红色系
                if (wordName.includes('团委') || wordName.includes('共青团')) return '#FF4444';

                // 教育相关 - 蓝色系
                if (
                  wordName.includes('学校') ||
                  wordName.includes('教育') ||
                  wordName.includes('学生') ||
                  wordName.includes('老师')
                )
                  return '#4488FF';

                // 安全问题 - 橙色系
                if (
                  wordName.includes('安全') ||
                  wordName.includes('霸凌') ||
                  wordName.includes('诈骗') ||
                  wordName.includes('暴力')
                )
                  return '#FF8844';

                // 意外伤害类 - 红橙色系
                if (
                  wordName.includes('意外') ||
                  wordName.includes('事故') ||
                  wordName.includes('伤害') ||
                  wordName.includes('溺水') ||
                  wordName.includes('坠楼') ||
                  wordName.includes('烫伤') ||
                  wordName.includes('中毒') ||
                  wordName.includes('火灾') ||
                  wordName.includes('爆炸') ||
                  wordName.includes('车祸') ||
                  wordName.includes('骨折') ||
                  wordName.includes('急救')
                )
                  return '#FF6644';

                // 心理危机 - 深红色系（最高优先级）
                if (
                  wordName.includes('自杀') ||
                  wordName.includes('自残') ||
                  wordName.includes('轻生') ||
                  wordName.includes('危机') ||
                  wordName.includes('绝望') ||
                  wordName.includes('厌世') ||
                  wordName.includes('极端') ||
                  wordName === '抑郁症' ||
                  wordName === '精神障碍'
                )
                  return '#CC0000';

                // 心理健康 - 紫色系
                if (
                  wordName.includes('心理') ||
                  wordName.includes('健康') ||
                  wordName.includes('压力') ||
                  wordName.includes('焦虑') ||
                  wordName.includes('情绪') ||
                  wordName.includes('治疗')
                )
                  return '#8844FF';

                // 活动相关 - 绿色系
                if (
                  wordName.includes('活动') ||
                  wordName.includes('比赛') ||
                  wordName.includes('志愿') ||
                  wordName.includes('实践')
                )
                  return '#44FF88';

                // 网络相关 - 青色系
                if (
                  wordName.includes('网络') ||
                  wordName.includes('网瘾') ||
                  wordName.includes('网课') ||
                  wordName.includes('数字')
                )
                  return '#44FFFF';

                // 地区名称 - 黄色系
                if (
                  [
                    '南宁',
                    '桂林',
                    '柳州',
                    '北海',
                    '梧州',
                    '玉林',
                    '百色',
                    '贵港',
                    '河池',
                    '来宾',
                    '崇左',
                    '防城港',
                    '钦州',
                    '贺州',
                  ].includes(wordName)
                )
                  return '#FFD700';

                // 特殊高亮词汇
                if (wordName === '青少年心理健康') return '#FF0080';
                if (wordName === '校园安全') return '#FF4500';
                if (wordName === '青年大学习') return '#32CD32';

                // 默认随机颜色
                return (
                  'rgb(' +
                  [
                    Math.round(Math.random() * 180 + 75),
                    Math.round(Math.random() * 180 + 75),
                    Math.round(Math.random() * 180 + 75),
                  ].join(',') +
                  ')'
                );
              },
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: '#2ac',
            },
          },
          data: datas,
        },
      ],
    };
  }

  init() {
    const el = (this as any).$refs.chartRef as any;
    this.myChart = echarts.init(el);
    this.updateChart();
  }
}
